(() => {
  'use strict';
  if (!window.customElements || customElements.get('oliw87-archive')) return;
  class Oliw87Archive extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._listeners = [];
      this._links = Array.from(this.querySelectorAll('[data-bbb-photo]'));
      this._dialog = this.querySelector('.bbb-lightbox');
      if (this.dataset.lightboxEnabled !== 'true' || !this._links.length || !this._dialog || typeof this._dialog.showModal !== 'function') return;
      this._image = this.querySelector('[data-bbb-image]');
      this._title = this.querySelector('[data-bbb-title]');
      this._caption = this.querySelector('[data-bbb-caption]');
      this._close = this.querySelector('[data-bbb-close]');
      this._current = 0;
      this._returnFocus = null;
      this._touchStart = null;
      this._links.forEach((link, index) => this._on(link, 'click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault();
        this._returnFocus = link;
        this._display(index);
        if (!this._dialog.open) this._dialog.showModal();
        document.body.classList.add('oliw87-bbb-modal-open');
        this._close.focus();
      }));
      this._on(this._close, 'click', () => this._dialog.close());
      this._on(this.querySelector('[data-bbb-prev]'), 'click', () => this._display(this._current - 1));
      this._on(this.querySelector('[data-bbb-next]'), 'click', () => this._display(this._current + 1));
      this._on(this._dialog, 'keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          event.stopPropagation();
          this._display(this._current + (event.key === 'ArrowRight' ? 1 : -1));
        } else if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this._dialog.close();
        }
      });
      this._on(this._dialog, 'close', () => this._finishClose());
      const stage = this.querySelector('[data-bbb-stage]');
      this._on(stage, 'touchstart', event => {
        this._touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      this._on(stage, 'touchend', event => {
        if (!this._touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this._touchStart.x;
        const dy = event.changedTouches[0].clientY - this._touchStart.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this._display(this._current + (dx < 0 ? 1 : -1));
        this._touchStart = null;
      }, { passive: true });
      this._on(stage, 'touchcancel', () => { this._touchStart = null; }, { passive: true });
      // Shopify replaces section DOM when settings change. Custom element lifecycle
      // handles fresh sections; selecting a block closes the image viewer for editing.
      this._on(this, 'shopify:block:select', () => { if (this._dialog.open) this._dialog.close(); });
    }
    _on(target, event, listener, options) {
      target.addEventListener(event, listener, options);
      this._listeners.push([target, event, listener, options]);
    }
    _display(index) {
      this._current = (index + this._links.length) % this._links.length;
      const link = this._links[this._current];
      this._image.src = link.href;
      this._image.alt = link.querySelector('img').alt;
      this._title.textContent = link.dataset.title;
      const description = link.dataset.caption ? ` — ${link.dataset.caption}` : '';
      this._caption.textContent = `${String(this._current + 1).padStart(2, '0')} / ${this._links.length}${description}`;
    }
    _finishClose() {
      if (!document.querySelector('oliw87-archive .bbb-lightbox[open]')) document.body.classList.remove('oliw87-bbb-modal-open');
      this._touchStart = null;
      if (this._returnFocus && this._returnFocus.isConnected) this._returnFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      if (this._dialog && this._dialog.open) this._dialog.close();
      if (this._listeners) this._listeners.forEach(([target, event, listener, options]) => target.removeEventListener(event, listener, options));
      this._finishClose();
      this._ready = false;
    }
  }
  customElements.define('oliw87-archive', Oliw87Archive);
})();
